const category = {
  breadcrumb_home: '首页',
  breadcrumb_categories: '分类浏览',
  all_categories: '全部分类',
  articles_count: '篇文章',
  back_to_categories: '返回分类',
};

export default category;